import {RangeSlider} from "~shared/components/range-slider";
import {applyCustomSelect} from "~shared/components/custom-select";
import {groupBy} from "lodash-es";

ready().then(function () {
    //Form
    let searchWrapper = $('#search');
    let filterForm = searchWrapper.find('form');
    let formInputs = filterForm.find('input, select');

    //Topbar
    let searchTabs = $('.tab-buttons a');
    let chosenFiltersDiv = $('.search-chosen-filters');

    //Pagination
    let page = 1;

    //Post data
    const action = filterForm.data('action');
    const ajaxUrl = filterForm.data('url');
    const engine = filterForm.data('engine');
    const path = filterForm.data('path');

    const breadcrumbsDiv = $('.section-breadcrumbs');
    const resultsDiv = $('.search-results');
    const resultsTopBar = $('.search-top-bar');
    const paginationDiv = $('.search-pagination');
    const sidebarDiv = $('.search-sidebar');
    const introDiv = $('.search-intro');
    const outroDiv = $('.search-outro');

    let ajaxRequest;
    let queryString = '';
    let requestData = [];

    let currentPath = '';

    init();

    function init() {
        filterForm = searchWrapper.find('form');
        formInputs = filterForm.find('input, select');

        handleToggleGroups();
        handleToggleSideBar();
        setRangeSliders();
        setPagination();
        handleSubFilterHierarchy();
        handleCheckedFilters();
        setFilterSideBar();
        collapseFilters();
    }

    function setRangeSliders() {
        $('.filter-type-range').each(function () {
            new RangeSlider(this);
        });
    }

    function setFilterSideBar() {
        formInputs.on('change', function (e) {
            collectFilteredData();
        });

        filterForm.on('submit', function (e) {
            e.preventDefault();
            collectFilteredData();
        });
    }

    function setPagination() {
        paginationDiv.find('a').on('click', function (e) {
            e.preventDefault();

            let pageUrl = $(this).attr('href');
            let urlArr = pageUrl.split('/');
            let pageNumber = urlArr[urlArr.indexOf('page') + 1];

            $("html, body").animate({scrollTop: 0}, 300);

            collectFilteredData(pageNumber);
        });
    }

    /**
     * Serialize data for post and querystring
     */
    function collectFilteredData(pageNumber = 1) {
        requestData = filteredInputs(formInputs);
        page = pageNumber;

        handleCheckedFilters();
        handleSubFilterHierarchy();
        insertUrl(requestData);
        postData(requestData.serializeObject());
    }

    function filteredInputs(inputs) {
        return inputs
            .filter(filterEmptyValues)
            .filter(filterRangeLimits)
    }


    /**
     * Update rel links in head (next/prev)
     */
    function updateRelLinks(maxPages, currentPage) {

        // Strip off page number from url
        let urlWithoutPage = $(location).attr('href').split('/page/')[0];

        // Remove old ones first
        $('head link[rel="prev"]').remove();
        $('head link[rel="next"]').remove();

        if (maxPages > 1 && currentPage > 1) {
            $('head').append('<link rel="prev" href="' + urlWithoutPage + '/page/' + (currentPage - 1) + '/" />');
        }
        if (maxPages > 1 && currentPage < maxPages) {
            $('head').append('<link rel="next" href="' + urlWithoutPage + '/page/' + (currentPage + 1) + '/" />');
        }
    }


    /**
     * Insert into url bar and update tabs href
     * @param requestData
     * @param pageNumber
     */
    function insertUrl(requestData, pageNumber) {
        let requestArray = requestData.serializeArray();
        let tabIgnoreParameters = [
            'attachment_type',
            'attachment_type[]'
        ];

        currentPath = '/' + filterForm.data('path') + '/' + prettyUrlPathAndQueryString(requestArray);
        currentPath = currentPath.replace('//', '/'); // Fix accidental double slashes

        history.pushState({data: requestData.serializeObject()}, document.title, currentPath);

        // Remove any parameters from canonicalUrl
        let canonicalUrl = window.location.origin + currentPath;
        $('link[rel="canonical"]').attr('href', canonicalUrl.split('?')[0]);

        // Remove these filter parameters as they can cause 0 results when switching tabs
        requestArray = requestArray.filter(function (item) {
            return tabIgnoreParameters.indexOf(item.name) === -1;
        });

        if (requestArray.length > 0) {
            queryString = '?' + $.param(requestArray);
        } else {
            queryString = '';
        }

        // Pass same applied filters to different search pages
        $.each(searchTabs, function (key, tab) {
            $(tab).attr('href', $(tab).data('link') + queryString);
        });
    }

    if (document.getElementsByTagName('body')[0].classList.contains('archive')) {
        window.addEventListener('popstate', (event) => {
            if (event.state === null) {
                location.reload();
            }
            postData(event.state.data);
        });
    }

    /**
     * Try to make URL path & query string as pretty as possible
     * @param requestArray
     * @returns {string}
     */
    function prettyUrlPathAndQueryString(requestArray) {
        let groups = groupBy(requestArray, 'name');
        let groupKeys = Object.keys(groups);
        let primaryChoice = null;
        let urlSuffix = '';
        let queryString = '';

        // Make the URL pretty when 1 choice is made within 1 group
        if (groupKeys.length === 1 && groups[groupKeys[0]].length === 1) {
            primaryChoice = groups[groupKeys[0]][0]; // Use only item available within the object (simple)
        }

        // Make the URL pretty when multiple choices on the 3rd level are made within 1 group.
        // Use the 2nd level <input> for the pretty URL and 3rd level <input>'s as query string
        if (groupKeys.length === 1 && groups[groupKeys[0]].length > 1) {
            // Traverse based on DOM (complex)
            primaryChoice = formInputs.filter(function () {
                return $(this).attr('name') === groupKeys[0] && $(this).data('depth') === 1 && $(this).is(':checked');
            }).map(function () {
                return {
                    name: this.name,
                    value: this.value
                };
            })[0];
        }

        // Make pretty URL when a primary choice is found
        if (primaryChoice) {
            let inputWithPath = formInputs.filter('[name="' + primaryChoice.name + '"][value="' + primaryChoice.value + '"][data-path]');

            // When input is found matching our conditions
            if (inputWithPath.length === 1) {
                // Set URL path from data-path attribute
                urlSuffix = inputWithPath.data('path');
                // Remove primary choice from query string
                requestArray = requestArray.filter(function (item) {
                    return !(item.name === primaryChoice.name && item.value === primaryChoice.value);
                });
            }
        }

        // Build query string
        queryString = $.param(requestArray);

        // Set page number for request and add to path. Only add to path if page > 1
        if (page > 1) {
            urlSuffix += 'page/' + page + '/';
        }

        // Add query string when relevant at the end
        if (queryString.length > 1) {
            urlSuffix += '?' + queryString;
        }

        return urlSuffix;
    }

    /**
     * Post data
     * @param data
     */
    function postData(data) {
        if (ajaxRequest) {
            ajaxRequest.abort();
        }

        data = $.extend(data, {
            'action': action,
            'engine': engine,
            'path': path,
            'page': page
        });

        resultsDiv.addClass('loading');
        openPageLoader();

        ajaxRequest = $.ajax(ajaxUrl, {
            type: 'POST',
            data: data,
            dataType: 'json',
        }).done(function (data) {
            replaceHtml(data);
            init();
            applyCustomSelect("select"); // when the request is complete, load the customSelect script again
            trimAuthorDescriptionCards();
            applyHighestImgSize();
            removePageLoader();
            resultsDiv.removeClass('loading');
            introDiv.removeClass('has-no-text');
            outroDiv.removeClass('has-no-text');
            toggleText();
            $("html, body").animate({scrollTop: 0}, 300);
        });
    }

    /**
     * Update HTML with latest version
     * @param response
     */
    function replaceHtml(response) {
        const $responseHtml = $('<div></div>').append($(response.html))
        const replaceDivs = [
            '.section-breadcrumbs',
            '.search-intro',
            '.search-sidebar',
            '.search-results',
            '.search-top-bar',
            '.search-pagination',
            '.search-outro'
        ];

        if (response.data.page_title) {
            $('h1.page-title').html(response.data.page_title);
        }

        if (response.data.page_description) {
            $('meta[name="description"], meta[name="twitter:description"], meta[property="og:description"]').attr('content', response.data.page_description);
        }

        if (response.data.pagination.maxPages && response.data.pagination.currentPage) {
            updateRelLinks(response.data.pagination.maxPages, response.data.pagination.currentPage);
        }

        $.each(replaceDivs, function (key, selector) {
            $(selector).html($responseHtml.find(selector).html());
        });
    }

    /**
     * Set chosen filters in top bar. Checkboxes, radios and range.
     */
    function handleCheckedFilters() {
        chosenFiltersDiv.html('' +
            '<span class="text">Gekozen filters: </span>' +
            '<ul class="chosen-filters"></ul>' +
            '<span class="uncheck-all has-icon icon-close">Wis alle filters</span>'
        );

        let inputs = filteredInputs(formInputs);

        let checkedBoxes = inputs.filter(filterChecked);
        let rangeFilters = inputs.filter(filterRangeSlider);
        let selectedDropdowns = inputs.find('option').filter(filterSelected);

        chosenFiltersDiv.addClass('is-hidden');

        $.each([...checkedBoxes, ...rangeFilters, ...selectedDropdowns], function (key, filter) {
            addLabels(filter)
            chosenFiltersDiv.removeClass('is-hidden');
        });

        chosenFiltersDiv.find('li').on('click', function () {
            uncheckFilter(this);
            collectFilteredData();
        });

        chosenFiltersDiv.find('.uncheck-all').on('click', uncheckAll);
    }

    function addLabels(filter) {
        let labelText = $(filter).data('filter-label');
        labelText += filter.type === 'text' ? filter.value : '';

        //Add range value to label
        let liElement = $("<li>", {
            id: $(filter).attr('class'),
            html: labelText.stripTags()
        });

        chosenFiltersDiv.find('ul').append(liElement);
    }

    /**
     * Uncheck filter
     * @param label
     */
    function uncheckFilter(label) {
        let option = filterForm.find('.' + label.id);

        //Uncheck checkbox / radio
        option.prop("checked", false);

        //Uncheck selected
        option.prop("selected", false);

        //Reset range
        if (typeof option.data('limit') !== 'undefined') {
            option.val(option.data('limit')).trigger('change');
        }
    }

    /**
     * Uncheck all
     */
    function uncheckAll() {
        $.each(chosenFiltersDiv.find('li'), function () {
            uncheckFilter(this);
        });

        collectFilteredData();
    }

    function handleToggleGroups() {
        $('.toggle-group').on('click', function (e) {
            e.preventDefault();

            var group = $(this);

            if (group.hasClass('show')) {
                group.removeClass('show');
                group.next('.option-wrapper').slideUp(350);
            } else {
                group.addClass('show');
                group.next('.option-wrapper').slideToggle(350);
            }
        });
    }

    /**
     * Handle filters with depth
     */
    function handleSubFilterHierarchy() {
        let checkedDepthInput = filterForm.find('.has-depth').find('input:checked');
        let checkedOption = checkedDepthInput.closest('.option');

        //Hide all children
        filterForm.find('.has-depth:not(.option-depth-0)').hide();

        //Show children based on selection
        if (checkedOption.hasClass('option-depth-0')) {
            checkedOption
                .nextUntil('.option-depth-0')
                .not('.option-depth-2')
                .show()
        } else {
            checkedOption
                .prevAll('.option-depth-0')
                .first()
                .nextUntil('.option-depth-0')
                .not('.option-depth-2')
                .show();
        }
    }

    function handleToggleSideBar() {
        $('.toggle-sidebar').on('click', function (e) {
            e.preventDefault();
            $('.search-sidebar').toggleClass('is-open');
            $('body').toggleClass('is-fixed');
        });
    }


    /***********************************************
     * FILTERS
     ***********************************************/

    /**
     * Remove filters with empty value. E.g. for default sort option
     * @returns {boolean}
     */
    function filterEmptyValues() {
        return !!this.value;
    }

    /**
     * Filter checked inputs
     * @returns {jQuery}
     */
    function filterChecked() {
        return $(this).prop('checked') && $(this).data('filter-label');
    }

    /**
     * Filter select inputs
     * @returns {jQuery}
     */
    function filterSelected() {
        return $(this).prop('selected') && $(this).data('filter-label');
    }

    /**
     * Filter range slider inputs
     * @returns {boolean}
     */
    function filterRangeSlider() {
        return typeof $(this).data('limit') !== 'undefined' && $(this).data('filter-label');
    }

    /**
     * Only add range filter parameters if not on limit
     * @returns {boolean}
     */
    function filterRangeLimits() {
        let limit = $(this).data('limit');
        if (typeof limit !== 'undefined') {
            return limit !== parseInt(this.value);
        }

        return true;
    }

    /**
     * Collapse filters, only if nothing is selected
     */
    function collapseFilters() {
        let filterGroups = sidebarDiv.find('.filter-group');

        filterGroups.each(function() {
            const $group = $(this);

            // Get all top-level options:
            // - Either options without any depth class
            // - Or options with depth-0 class
            const $allOptions = $group.find('.option');
            const $topLevelOptions = $allOptions.filter(function() {
                const $option = $(this);
                // Is a top-level option if:
                // - Has depth-0 class (for multi-level filters)
                // - OR doesn't have has-depth class at all (single-level filters)
                return $option.hasClass('option-depth-0') || !$option.hasClass('has-depth');
            });

            const $showMoreBtn = $group.find('.show-more');
            const $showLessBtn = $group.find('.show-less');

            // Check if this group should be collapsible (more than 10 top-level options)
            if ($topLevelOptions.length > 10) {
                const $lastItems = $topLevelOptions.slice(10);
                const hasCheckedItems = $group.find('.option input:checked').length > 0;

                // Add collapsed class if not present
                $group.addClass('filter-collapsed');

                if (hasCheckedItems) {
                    // If any items are checked, show all and hide toggles
                    $lastItems.show();
                    $showMoreBtn.hide();
                    $showLessBtn.hide();
                } else {
                    // Initial collapsed state
                    $lastItems.hide();
                    $showMoreBtn.show();
                    $showLessBtn.hide();
                }
            } else {
                // Remove collapsed class and hide toggles for groups with <= 10 items
                $group.removeClass('filter-collapsed');
                $showMoreBtn.hide();
                $showLessBtn.hide();
            }
        });

        // Remove old event handlers and add new ones
        sidebarDiv.find('.show-more').off('click').on('click', function() {
            const $group = $(this).closest('.filter-group');
            const $topLevelOptions = $group.find('.option').filter(function() {
                return $(this).hasClass('option-depth-0') || !$(this).hasClass('has-depth');
            });
            const $lastItems = $topLevelOptions.slice(10);

            $lastItems.slideDown(350);
            $(this).hide();
            $group.find('.show-less').show();
        });

        sidebarDiv.find('.show-less').off('click').on('click', function() {
            const $group = $(this).closest('.filter-group');
            const $topLevelOptions = $group.find('.option').filter(function() {
                return $(this).hasClass('option-depth-0') || !$(this).hasClass('has-depth');
            });
            const $lastItems = $topLevelOptions.slice(10);

            $lastItems.slideUp(350);
            $(this).hide();
            $group.find('.show-more').show();
        });
    }

});
